<template>
  <footer>
    <hr />
    <small>
      <fa-icon icon="copyright" /> 2025 Pain Medics. All rights reserved.
    </small>
  </footer>
</template>

<script>
export default {
  name: "NavBar"
};
</script>

<style scoped>
footer {
  width: 100%;
  text-align: center;
  opacity: 0.7;
  float: right;
  font-size: 1.2vw;
}

address {
  display: inline-block;
  font-style: normal;
}

hr {
  width: 80%;
  opacity: 0.2;
  height: 1px;
  background-color: gray;
}

fa-icon {
  transform: scale(1.1);
  opacity: 0.2;
}
</style>
